<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('voidInvoice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('voidInvoice.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('voidInvoice.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('voidInvoice.branchName')
                      }}</label>
                      <a-select style="width:100%" v-model.number="model.branch_id" :options="branches"
                        @change="onBranchChange"></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('voidInvoice.date')
                      }}</label>
                      <a-range-picker style="width:100%" v-model="model.date_range" format="DD-MM-YYYY" />
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{
                        $t('voidInvoice.invoiceNumber')
                      }}</label>
                      <a-select style="width:100%" v-model="model.inv_number" mode="multiple" :options="invoices"
                        :show-search="true" :filter-option="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                          " :placeholder="$t('all')"></a-select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button color="primary" @click.prevent="preview" :waiting="waiting">{{ $t('preview')
                      }}</ts-button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('voidInvoice.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'voidInvoice',
  data() {
    return {
      loading: false,
      waiting: false,
      src: '',
      errors: new Errors(),
      branches: [],
      invoices: [],
      model: {
        branch_id: null,
        inv_number: undefined,
        date_range: [moment().startOf('month'), moment()]
      }
    }
  },
  created() {
    this.model.branch_id = this.$store.state.authUser.default_branch_id
    this.fetchData()
    this.fetchInvoice()
  },
  methods: {
    ...mapActions('reportPayment', ['voidInvoice', 'getBranch', 'getFormViewData']),
    moment,
    async fetchData() {
      this.loading = true
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchInvoice(){
      this.loading = true
      this.getFormViewData({
        params: {
						fnName: "invoice",
						branch_id: [this.model.branch_id]
					}
      })
        .then(response => {         
          this.invoices = response.invoice.map(el => ({
            value: el.inv_number,
            label: el.inv_number
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onBranchChange() {
      this.model.inv_number = undefined
      this.fetchInvoice()
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.voidInvoice(Object.assign({}, this.model, {
        date_range: [
          this.model.date_range[0].format('DD-MM-YYYY'),
          this.model.date_range[1].format('DD-MM-YYYY')
        ]
      }))
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
